import { Box, Modal } from "@mui/material";
import React from "react";
import { colorConstant } from "../../../../../../styles/colorConstant/colorConstant";
import "./CancelAndConfirmModal.css";
import { PosCustomButton } from "../../../../../../customComponents/PosCustomButton/PosCustomButton";
import { useNavigate } from "react-router-dom";

const CancelAndConfirmModal = ({ cancelAndConfirmModalOpen, setCancelAndConfirmModalOpen, cancelTitle, confirmTitle }) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 360,
    height: "23%",
    bgcolor: `${colorConstant.surfaceWhite}`,
    p: 2,
    borderRadius: "12px",
  };

  const navigate = useNavigate();

  //Handle Modal Close
  const handleClose = () => {
    setCancelAndConfirmModalOpen(false);
  };

  //On Click cancel navigate to previous page
  const handleCancel = () => {
    navigate(-1);
  }

  return (
    <div>
      <Modal
        open={cancelAndConfirmModalOpen}
        onClose={handleClose}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.1)",
            },
          },
        }}
      >
        <Box sx={style}>
          <div>
            <p className="cancelModalHeading">Are you sure you want to cancel and go back ?</p>
            <div className="cancelModalActionButtons">
              <PosCustomButton
                variant="red-transparent"
                title={cancelTitle}
                p={"12px 8px 12px 8px"}
                width={"100%"}
                radius="6px"
                onClickFunction={handleCancel}
              />
              <PosCustomButton
                variant="blue-d"
                title={confirmTitle}
                p={"12px 8px 12px 8px"}
                width={"100%"}
                radius="6px"
                onClickFunction={handleClose}
              />
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default CancelAndConfirmModal;
